// removed by extract-text-webpack-plugin
module.exports = {"slideDownReveal":"src-components-elements-SlideDownReveal-__SlideDownReveal-module___slideDownReveal"};


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/SlideDownReveal/SlideDownReveal.module.css
// module id = 1033
// module chunks = 1